import { render, staticRenderFns } from "./editor2.vue?vue&type=template&id=2b9f7906&lang=pug"
import script from "./editor2.vue?vue&type=script&lang=coffee"
export * from "./editor2.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports